module.exports = __webpack_public_path__ + "static/media/chevron-left.73577265.svg";